import { useRouter } from 'vue-router';

import {
    getBackState,
    saveBackState,
    clearBackState,
    setPendingRestoreContext,
} from '@/composables/useBackState';

export default function useBackRoute() {
    const router = useRouter();

    const goBack = () => {
        const state = getBackState();

        if (state?.stack?.length) {
            const stack = [...state.stack];
            const frame = stack.pop();

            if (!frame) {
                return;
            }

            if (frame.pageData) {
                setPendingRestoreContext({
                    pageName: frame.fromPageName,
                    pageData: frame.pageData,
                });
            }

            if (stack.length) {
                saveBackState({ stack });
            } else {
                clearBackState();
            }

            router.push(frame.fromPath);
            return;
        }

        if (window.history.length > 1) {
            router.back();
            return;
        }

        router.push({ name: 'main' });
    };

    return {
        goBack,
    };
}
